import { DateTime } from "luxon"

const TIMEZONE = "Europe/Zurich"

const generateTimeOptions = (selectedDate: DateTime) => {
    const times: DateTime[] = []

    let time = selectedDate.startOf("day")
    const endTime = selectedDate.endOf("day")

    while (time <= endTime) {
        times.push(time)
        time = time.plus({ minutes: 15 })
    }

    return times
}

export const getTimeOptions = (delay: number, selectedDate: Date) => {
    const nowCH = DateTime.now().setZone(TIMEZONE)

    // round to nearest 15 and add delay
    let limitTime = nowCH
        .minus({ minutes: nowCH.minute % 15 })
        .plus({ minutes: delay })

    const selectedCH = DateTime.fromJSDate(selectedDate).setZone(TIMEZONE)
    const sameDay = nowCH.hasSame(selectedCH, "day")

    return generateTimeOptions(selectedCH)
        .filter(chTime => {
            const dayOfWeek = chTime.weekday // Mon=1 ... Sun=7
            const hour = chTime.hour
            const minute = chTime.minute

            // closed Mondays
            if (dayOfWeek === 1) return false

            // ✅ only between 17:00 and 21:30
            const afterOpen = hour > 17 || (hour === 17 && minute >= 0)
            const beforeClose = hour < 21 || (hour === 21 && minute <= 30)

            if (!(afterOpen && beforeClose)) return false

            // on same day, skip past times
            if (sameDay && chTime < limitTime) return false

            return true
        })
        .map(dt => dt.toJSDate())
}


// import { DateTime } from "luxon"

// const TIMEZONE = "Europe/Zurich"

// const generateTimeOptions = (selectedDate: DateTime) => {
//     const times: DateTime[] = []

//     let time = selectedDate.startOf("day")
//     const endTime = selectedDate.endOf("day")

//     while (time <= endTime) {
//         times.push(time)
//         time = time.plus({ minutes: 15 })
//     }

//     return times
// }

// export const getTimeOptions = (delay: number, selectedDate: Date) => {

//     const nowCH = DateTime.now().setZone(TIMEZONE)

//     let limitTime = nowCH
//         .minus({ minutes: nowCH.minute % 15 }) // round down to nearest 15 min
//         .plus({ minutes: delay })

//     const selectedCH = DateTime.fromJSDate(selectedDate).setZone(TIMEZONE)
//     const sameDay = nowCH.hasSame(selectedCH, "day")

//     return generateTimeOptions(selectedCH)
//         .filter(chTime => {
//             if (sameDay && chTime < limitTime) return false

//             const dayOfWeek = chTime.weekday // Mon=1 ... Sun=7
//             const hour = chTime.hour
//             const minute = chTime.minute

//             if (dayOfWeek >= 1 && dayOfWeek <= 5) {
//                 return (
//                     (hour === 13 && minute === 0) ||
//                     (hour >= 11 && hour < 13) ||
//                     (hour > 17 || (hour === 17 && minute >= 30))
//                 )
//             }

//             if (dayOfWeek === 6 || dayOfWeek === 7) {
//                 return (
//                     (hour >= 11 && hour < 14) ||
//                     (hour > 16 || (hour === 16 && minute >= 30))
//                 )
//             }

//             return false
//         })
//         .map(dt => dt.toJSDate())
// }